import Avatar from '@mui/joy/Avatar'
import Typography from '@mui/joy/Typography'
import React from 'react'

type ImageStampProps = {
  collected: boolean
  font: string
  stampImagePath: string
  textColor: string
  date: string
  stamped: boolean
}

function ImageStamp(props: ImageStampProps) {
  return (
    <>
      <Avatar
        size="lg"
        variant="outlined"
        src={props.stampImagePath}
        className={`stamp-icon ${props.stamped && props.collected ? 'stamped' : ''}`}
        sx={{
          border: `2px solid ${props.textColor}`,
        }}
      />
      <Typography
        level="body-sm"
        textColor={props.textColor}
        fontFamily={props.font}
        sx={{ pt: 0.5, color: props.textColor, zIndex: 1 }}
        fontSize={16}
      >
        {props.date}
      </Typography>
    </>
  )
}

export default ImageStamp
